import React, {useContext} from 'react';
import {useFormState} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import classnames from '@src/helpers/classnames';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import {IPurchaseModel} from '@src/@interfaces/models/Purchase/IPurchaseModel';

export function NumericField({rowIndex: index, step, ...props}: IListColumnProps & { step: number }) {
    const {
        control,
        fieldName,
        forceReadonly,
        forceDisabled,
    } = useContext<IFormFieldItemPropsContext<IPurchaseModel> | null>(FormFieldItemPropsContext) ?? {};
    const [design] = useContext(FormFieldDesignContext);
    const {errors} = useFormState<IPurchaseModel>({control});

    if (!control) {
        return null;
    }

    return <>
        <input
                type={props.config.type}
                className={classnames('form-control form-control-sm', {
                    'is-invalid': Boolean(errors.materials?.[index]?.[props.config.name])
                })}
                step={step}
                min={0}
                {...control.register(`${fieldName}.${index}.${props.config.name}`)}
                readOnly={design.fieldsAreReadOnly || forceReadonly}
                disabled={design.fieldsAreDisabled || forceDisabled}
        />

        <FormErrorMessage fieldName={`${fieldName}.${index}.${props.config.name}`}/>
    </>;
}
